export default __webpack_public_path__ + "static/media/PW18.d7dfd490.pdf";